import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Card, Button, Modal, Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Stepper from '../../component/stepper/Stepper';
import { pythonAxiosInstance } from '../../config/ConfigInfo';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';
import { getItem, setItem } from '../../config/localStorage';
import SpinLoader from '../../component/loader/SpinLoader';
import PreviewTemplate from '../../component/preview/PreviewTemplate';

function Summary() {
    const jobTitle = getItem('jobTitle');
    const saveSummaryTitle = getItem('summaryItem');
    const checkSummaryTitle = saveSummaryTitle ? saveSummaryTitle.split('</p>') : '';
    const summaryCount = saveSummaryTitle ? saveSummaryTitle.replace(/<[^>]*>/g, '').length : null;

    let saveSummaryTitleList;
    if (saveSummaryTitle) {
        function removeHtmlTags(str) {
            return str.replace(/<\/?[^>]+(>|$)/g, "");
        }
        saveSummaryTitleList = checkSummaryTitle.filter(item => item.trim() !== "").map(removeHtmlTags);
    }

    const [tipsModalShow, setTipsModalShow] = useState(false);
    const [summaryTabOne, setsummaryTabOne] = useState(true);
    const [summaryTabTwo, setsummaryTabTwo] = useState(false);

    const [searchInput, setSearchInput] = useState('');
    const [loader, setLoader] = useState(true);
    const [error, setError] = useState('');
    const [summaryValidation, setSummaryValidation] = useState('');

    const [summaryList, setSummaryList] = useState([]);
    const [searchToggle, setSearchToggle] = useState(false);
    const [displaySummaryInEditor, setDisplaySummaryInEditor] = useState(saveSummaryTitle ? saveSummaryTitle : '');
    const [textCount, setTextCount] = useState(summaryCount ? summaryCount : 0);
    const summaryLimit = 500;


    const navigate = useNavigate();
    const location = useLocation();

    /** to handle next and previous click button start */

    const BackSkillPage = () => {
        navigate('/skill', { state: { skillFieldsTwo: true } });
    }

    const MovetoFinalizePage = () => {
        if (textCount === 0) {
            setSummaryValidation('Add a concise summary to highlight your professional background and key achievements.');
        } else {
            navigate('/finalize', { state: { moveFinalizePage: true } });
        }

    }

    useEffect(() => {

        if (location.state === null) {
            navigate('/resume-builder');
        } else {
            if (location.state.summaryFieldsOne === true) {
                summaryFieldsOne();
            }
            if (location.state.summaryFieldsTwo === true) {
                summaryFieldsTwo();
            }
        }

    }, []);

    /** to handle next and previous click button end    */


    const summaryFieldsOne = (e) => {
        setsummaryTabOne(true);
        setsummaryTabTwo(false);
    }

    const summaryFieldsTwo = (e) => {
        setsummaryTabOne(false);
        setsummaryTabTwo(true);
    }

    const editorConfiguration = {
        ui: {
            poweredBy: {
                forceVisible: true
            }
        },
        toolbar: [
            'bold',
            'italic'
        ],
        toolarLocation: 'bottom',
        placeholder: 'Text your summary here.',
    };

    /** search functionality start */

    const handleSummarySearch = (e) => {
        e.preventDefault();
        if (e.target.elements.searchSummary.value === '') {
            setError('Please enter the job title');
        } else {
            setSearchToggle(!searchToggle);
            setSearchInput(e.target.elements.searchSummary.value);
            setError('');
        }
    };

    /** search functionality end */

    /** call API to fetch the summary data start */

    useEffect(() => {

        (async () => {
            const raw = {
                job_title: searchInput === '' ? jobTitle : searchInput
            };
            try {
                setLoader(true);
                const response = await pythonAxiosInstance.post('generate-summary/', raw);
                if (response.data.summary_job_title) {
                    let updatedSkills;
                    if (saveSummaryTitleList) {
                        updatedSkills = response.data.summary_job_title.map((list) => {
                            const match = saveSummaryTitleList.find((item) => item === list.summary_title);
                            if (match) {
                                return { ...list, disabled: true };
                            }
                            return list;
                        });
                    } else {
                        updatedSkills = response.data.summary_job_title;
                    }

                    setLoader(false);
                    setSummaryList(updatedSkills);
                    setError('');
                }
            } catch (error) {
                setError(error.message);
                setLoader(false);
            }
        })()

    }, [searchInput, searchToggle]);

    /** call API to fetch the summary data end */

    const handleSummaryListClick = (itemName) => {
        const summaryListCopy = [...summaryList]
        const appendSummary = displaySummaryInEditor ? displaySummaryInEditor + '<p>' + itemName + '</p>' : '<p>' + itemName + '</p>';
        setDisplaySummaryInEditor(appendSummary);
        setItem('summaryItem', appendSummary);
        setSummaryValidation('');
        summaryListCopy.forEach(item => {
            if (displaySummaryInEditor.includes(item.summary_title)) {
                item.disabled = true;
            }
        });
        setSummaryList(summaryListCopy);
    }


    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        const strippedData = data.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/&nbsp;/g, ' ');
        const characterCount = data.replace(/<[^>]*>/g, '').length;

        setSummaryValidation('');

        const matchSkillsList = summaryList.map(dataItem =>
            strippedData.includes(dataItem.summary_title) ? { ...dataItem, disabled: true } : { ...dataItem, disabled: false }
        );

        setSummaryList(matchSkillsList);

        setTextCount(characterCount);
        setDisplaySummaryInEditor(data);
        setItem('summaryItem', data);
    };

    return (
        <>
            <section className='main-section padding-top-bottom skill-main-section'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='skill-card-option shadow border-0'>
                                <Stepper pagenumber='5' />
                                {
                                    summaryTabOne ?
                                        < Card.Body className='skill-part-one-main'>
                                            <Row>
                                                <Col md={9} className='skill-part-one-text-outer'>
                                                    <div className='skill-part-one-text'>
                                                        <h2>Summary</h2>

                                                        <p>Craft a compelling summary that encapsulates your professional background, key achievements, and career goals. This is your elevator pitch, so make it engaging and reflective of your unique value proposition.</p>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <ChangeTemplateLayout />
                                                </Col>
                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={BackSkillPage}>Back</Button>
                                                                <PreviewTemplate />
                                                                <Button className='my-next-btn button-green float-end' onClick={summaryFieldsTwo}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                                {
                                    summaryTabTwo ?
                                        <Card.Body className='skill-part-two-main'>
                                            <Row>
                                                <Col md={12} className='skill-part-two-text-outer'>
                                                    <div className='skill-part-two-text'>
                                                        <h2>Briefly tell us about your background</h2>
                                                        <p>Choose from our pre-written examples below or write your own.</p>
                                                        <div className='tool-tip'>
                                                            <div onClick={() => setTipsModalShow(true)}>
                                                                <div className='tool-tip-inner'>
                                                                    <i className="fa fa-lightbulb-o"></i> <span>Tips</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className='mt-3 mb-3 skill-ai-page'>
                                                    <Row>
                                                        <Col md={6} className='mb-3'>
                                                            <Col md={12} className='skill-left-section'>
                                                                <h6 className='text-center mt-2'>Search By Job Title For Pre-Written Examples</h6>
                                                                <Col md={12} className='ai-search-skill-form'>
                                                                    <Form onSubmit={handleSummarySearch}>

                                                                        <div className='ai-serach-form-section'>

                                                                            <div className='input-section'>
                                                                                <Form.Control
                                                                                    placeholder="Search By Job Title"
                                                                                    size="lg"
                                                                                    type='text'
                                                                                    id="searchSummary"
                                                                                />
                                                                            </div>

                                                                            <div className='button-section'>
                                                                                <button type="submit" className='search-skill-btn'><i className="fa fa-search"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </Form>

                                                                    {
                                                                        error ?
                                                                            <Col md={12} className='mt-3 d-inline-block w-100'>
                                                                                <div className="alert alert-danger" role="alert">
                                                                                    {error}
                                                                                </div>
                                                                            </Col> : ''
                                                                    }
                                                                </Col>
                                                                <Col md={12} className='mt-3 ai-search-skill-result-part'>
                                                                    <Card>
                                                                        <Card.Body>
                                                                            <Card.Title>Ready-to-use-examples</Card.Title>
                                                                            <div className='ai-list-item'>

                                                                                <ul>
                                                                                    {

                                                                                        loader === true ? <SpinLoader /> :
                                                                                            summaryList.map((item, index) => (
                                                                                                <li key={item.id} item={item.summary_title} >
                                                                                                    <div className='button-part'>
                                                                                                        <Button onClick={() => handleSummaryListClick(item.summary_title, index)} disabled={item.disabled}>
                                                                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                                        </Button>
                                                                                                    </div>
                                                                                                    <div className='text-part source-editor-1'>
                                                                                                        <p>{item.summary_title}</p>
                                                                                                    </div>
                                                                                                </li>
                                                                                            ))

                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                            </Col>
                                                        </Col>
                                                        <Col md={6} className='mb-3'>
                                                            <Col md={12} className='skill-right-section'>

                                                                <p><strong>Professional Summary</strong></p>
                                                                <div className='skill-right-content-part'>
                                                                    <div className='summary-editor '>
                                                                        <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={displaySummaryInEditor}
                                                                            config={editorConfiguration}
                                                                            onChange={handleEditorChange}
                                                                        />
                                                                    </div>

                                                                </div>

                                                            </Col>

                                                            {
                                                                summaryValidation ? <div className="alert alert-danger mt-3" role="alert">{summaryValidation}</div> : ''
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={summaryFieldsOne}>Back</Button>
                                                                <Button className='my-next-btn button-green float-end' onClick={MovetoFinalizePage}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                            </Card>
                        </Col>
                    </Row>
                </Container >
            </section >

            <SummaryTipsModal
                show={tipsModalShow}
                onHide={() => setTipsModalShow(false)}
            />
        </>
    )
}

function SummaryTipsModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Summary Tips
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='summary-tips-section'>
                    <p><strong>1) Be Concise and Specific:</strong></p>
                    <ul>
                        <li>Keep your professional summary to 3-5 sentences. Clearly and succinctly highlight your key qualifications and career goals. Avoid vague statements; be specific about your skills and achievements.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>2) Tailor to the Job:</strong></p>
                    <ul>
                        <li>Customize your summary for each job application. Focus on the skills and experiences that are most relevant to the position you’re applying for, aligning your summary with the job description.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>3) Highlight Key Achievements:</strong></p>
                    <ul>
                        <li>Include one or two major accomplishments that demonstrate your capabilities and impact in previous roles. Quantify these achievements with numbers, percentages, or specific results where possible.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>4) Showcase Your Unique Value Proposition:</strong></p>
                    <ul>
                        <li>Emphasize what sets you apart from other candidates. This could be a unique combination of skills, a particular area of expertise, or an innovative approach you bring to your work.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>5) Incorporate Relevant Keywords:</strong></p>
                    <ul>
                        <li>Use keywords from the job posting in your summary. Many employers use applicant tracking systems (ATS) to screen resumes, and including relevant keywords can help your resume get noticed.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>6) Focus on Career Progression:</strong></p>
                    <ul>
                        <li>Provide a brief overview of your career trajectory, highlighting how you’ve progressed and developed over time. This shows your growth and readiness for the next step in your career.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>7) Include Your Professional Title:</strong></p>
                    <ul>
                        <li>o	Start with your professional title or a brief description of your role. For example, "Experienced Marketing Manager" or "Certified IT Specialist" sets the stage for the rest of your summary.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>8) Align with Company Values:</strong></p>
                    <ul>
                        <li>If you know the company’s mission or values, try to reflect them in your summary. Showing that your goals and values align with those of the company can make a strong impression.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>9) Use a Professional Tone:</strong></p>
                    <ul>
                        <li>Maintain a professional tone throughout your summary. Avoid slang or overly casual language. Aim for a balance of confidence and humility.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>10) Edit and Proofread:</strong></p>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>11) Mention Your Dream Job:</strong></p>
                    <ul>
                        <li>Briefly indicate how the position you’re applying for aligns with your long-term career aspirations. This demonstrates to the employer that you are passionate about the role and see it as a meaningful step towards your dream job.</li>
                    </ul>
                </div>

                <div className='summary-tips-section'>
                    <p><strong>12) Outline Your Career Goals:</strong></p>
                    <ul>
                        <li>Clearly state your short-term and long-term career goals. This shows potential employers that you have a vision for your future and that you are ambitious and forward-thinking. Ensure these goals are relevant to the position and the company you’re applying to.</li>
                    </ul>
                </div>

            </Modal.Body>
        </Modal>
    );
}

export default Summary
